import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/store';
import {mapState,mapGetters,mapActions} from 'vuex';
import global_ from '@/globalConfig/globalConfig';

const index				= resolve => require(['@/pages/index.vue'], resolve);
const login				= resolve => require(['@/pages/login.vue'], resolve);
const register			= resolve => require(['@/pages/register.vue'], resolve);
const pwdError			= resolve => require(['@/pages/pwdError.vue'], resolve);
const browserVersion	= resolve => require(['@/pages/browserVersion.vue'], resolve);
// 用户中心
const center			= resolve => require(['@/pages/center/center.vue'], resolve);
const user_info			= resolve => require(['@/pages/center/user_info.vue'], resolve);
const security_set		= resolve => require(['@/pages/center/security_set.vue'], resolve);
const modify_phone		= resolve => require(['@/pages/center/modify_phone.vue'], resolve);
const modify_pwd		= resolve => require(['@/pages/center/modify_pwd.vue'], resolve);
// 学校概况
const schoolProfile		= resolve => require(['@/pages/schoolProfile/schoolProfile.vue'], resolve);
//教室设备
const classroomDevice		= resolve => require(['@/pages/classroomDevice/classroomDevice.vue'], resolve);
// 教室
const classroomList		= resolve => require(['@/pages/classroom/classroomList.vue'], resolve);
// 环境
const environment		= resolve => require(['@/pages/environment/environment.vue'], resolve);
const environmentList	= resolve => require(['@/pages/environment/environmentList.vue'], resolve);
const environmentReport	= resolve => require(['@/pages/environment/environmentReport.vue'], resolve);
// 能耗
const energyList		= resolve => require(['@/pages/energy/energyList.vue'], resolve);
// 情景模式
const scene				= resolve => require(['@/pages/scene/scene.vue'], resolve);
const sceneList			= resolve => require(['@/pages/scene/sceneList.vue'], resolve);
const addScene			= resolve => require(['@/pages/scene/addScene.vue'], resolve);
// 设备检测
const equipment				= resolve => require(['@/pages/equipment/equipment.vue'], resolve);
const equipmentList			= resolve => require(['@/pages/equipment/equipmentList.vue'], resolve);
const subdeviceDetails			= resolve => require(['@/pages/equipment/subdeviceDetails.vue'], resolve);
// 配置参数
const configure			= resolve => require(['@/pages/configure/configure.vue'], resolve);
const configureList			= resolve => require(['@/pages/configure/configureList.vue'], resolve);
const modifyConfigure			= resolve => require(['@/pages/configure/modifyConfigure.vue'], resolve);
//定时策略
const timingStrategy				= resolve => require(['@/pages/timingStrategy/timingStrategy.vue'], resolve);
const timingStrategyList			= resolve => require(['@/pages/timingStrategy/timingStrategyList.vue'], resolve);
const addTimingStrategy			= resolve => require(['@/pages/timingStrategy/addTimingStrategy.vue'], resolve);
// 操作记录
const record			= resolve => require(['@/pages/record/record.vue'], resolve);
//帐号管理
const administratorAccount			= resolve => require(['@/pages/accountManagement/administratorAccount.vue'], resolve);
const schoolAccount			= resolve => require(['@/pages/accountManagement/schoolAccount.vue'], resolve);
const accountDetailed			= resolve => require(['@/pages/accountManagement/accountDetailed.vue'], resolve);
const accountList			= resolve => require(['@/pages/accountManagement/accountList.vue'], resolve);

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'hash',
	routes: [
		{
			path: '/',
			name: 'index',
			component: index,
			redirect:'/schoolProfile',
			meta: {
				keepAlive:false
			},
			children:[
				{
					path: '/schoolProfile',
					name: 'schoolProfile',
					component: schoolProfile,
					meta: {
						keepAlive:false
					},
				},
				{
					path: '/classroomDevice',
					name: 'classroomDevice',
					component: classroomDevice,
					meta: {
						keepAlive:false
					},
				},
				{
					path: '/classroom',
					name: 'classroom',
					component: classroomList,
					meta: {
						keepAlive:false
					},
				},
				{
					path: '/environment',
					name: 'environment',
					component: environment,
					redirect:'/environment/environmentList',
					meta: {
						keepAlive:false
					},
					children:[
						{
							path: 'environmentList',
							name: 'environmentList',
							component: environmentList,
							meta: {
								keepAlive:false
							},
						},
						{
							path: 'environmentReport',
							name: 'environmentReport',
							component: environmentReport,
							meta: {
								keepAlive:false
							},
						},
					]
				},
				{
					path: '/energy',
					name: 'energy',
					component: energyList,
					meta: {
						keepAlive:false
					},
				},
				{
					path: '/administratorAccount',
					name: 'administratorAccount',
					component: administratorAccount,
					redirect:'/administratorAccount/accountList',
					meta: {
						keepAlive:false
					},
					children:[
						{
							path: 'accountList',
							name: 'accountList',
							component: accountList,
							meta: {
								keepAlive:false
							},
						},
						{
							path: 'accountDetailed',
							name: 'accountDetailed',
							component: accountDetailed,
							meta: {
								keepAlive:false
							},
						},
					],
				},
				{
					path: '/schoolAccount',
					name: 'schoolAccount',
					component: schoolAccount,
					meta: {
						keepAlive:false
					},
				},
				{
					path: '/scene',
					name: 'scene',
					component: scene,
					redirect:'/scene/sceneList',
					meta: {
						keepAlive:false
					},
					children:[
						{
							path: 'sceneList',
							name: 'sceneList',
							component: sceneList,
							meta: {
								keepAlive:false
							},
						},
						{
							path: 'addScene',
							name: 'addScene',
							component: addScene,
							meta: {
								keepAlive:false
							},
						},
					]
				},
				{
					path: '/equipment',
					name: 'equipment',
					component: equipment,
					redirect:'/equipment/equipmentList',
					meta: {
						keepAlive:false
					},
					children:[
						{
							path: 'equipmentList',
							name: 'equipmentList',
							component: equipmentList,
							meta: {
								keepAlive:false
							},
						},
						{
							path: 'subdeviceDetails',
							name: 'subdeviceDetails',
							component: subdeviceDetails,
							meta: {
								keepAlive:false
							},
						},
					]
				},
				{
					path: '/timingStrategy',
					name: 'timingStrategy',
					component: timingStrategy,
					redirect:'/timingStrategy/timingStrategyList',
					meta: {
						keepAlive:false
					},
					children:[
						{
							path: 'timingStrategyList',
							name: 'timingStrategyList',
							component: timingStrategyList,
							meta: {
								keepAlive:false
							},
						},
						{
							path: 'addTimingStrategy',
							name: 'addTimingStrategy',
							component: addTimingStrategy,
							meta: {
								keepAlive:false
							},
						},
					]
				},
				{
					path: '/configure',
					name: 'configure',
					component: configure,
					redirect:'/configure/configureList',
					meta: {
						keepAlive:false
					},
					children:[
						{
							path: 'configureList',
							name: 'configureList',
							component: configureList,
							meta: {
								keepAlive:false
							},
						},
						{
							path: 'modifyConfigure',
							name: 'modifyConfigure',
							component: modifyConfigure,
							meta: {
								keepAlive:false
							},
						},
					]
				},
				{
					path: '/record',
					name: 'record',
					component: record,
					meta: {
						keepAlive:false
					},
				},
			]
		},
		{
			path: '/login',
			name: 'login',
			component: login,
			meta: {
				keepAlive:false,
				auth: 0
			}
		},
		{
			path: '/register',
			name: 'register',
			component: register,
			meta: {
				auth: 0
			}
		},
		{
			path: '/pwdError',
			name: 'pwdError',
			component: pwdError,
			meta: {
				auth: 0
			}
		},
		{
			path: '/browserVersion',
			name: 'browserVersion',
			component: browserVersion
		},
		// {
		// 	path: '/register',
		// 	name: 'register',
		// 	component: register,
		// 	meta: {
		// 		auth: 0
		// 	}
		// },
		// {
		// 	path: '/pwdError',
		// 	name: 'pwdError',
		// 	component: pwdError,
		// 	meta: {
		// 		auth: 0
		// 	}
		// },
		{
			path: '/center',
			name: 'center',
			component: center,
			redirect:'/user_info',
			children:[
				{
					path: '/user_info',
					name: 'user_info',
					component: user_info
				},
				{
					path: '/security_set',
					name: 'security_set',
					component: security_set
				},
				{
					path: '/security_set/modify_phone',
					name: 'modify_phone',
					component: modify_phone
				},
				{
					path: '/security_set/modify_pwd',
					name: 'modify_pwd',
					component: modify_pwd
				},
			],
		},
	]
});

const local = (auth, name) => {
	if(auth == 0 || auth == 2) {
		// localStorage.setItem('redirect',"register");
		return;
	}
	// 记录登陆之前访问的模块
	localStorage.setItem("redirect",name);
}

let flag = true;

const isLogin = (to, from, next) => {
	let tn = to.name,
		fn = from.name,
		tAuth = to.meta.auth,
		fAuth = from.meta.auth,
		un = store.state.userStore.username,
		ut = localStorage.getItem('usertype'),
		rd = localStorage.getItem("redirect"),
		isV = global_.IEVersion();

	//console.log(fn);
	//console.log(tn+'|'+tAuth+'|'+un);

	// 浏览器版本检测
	if(isV < 11 && isV != -1) {
		if(to.fullPath === '/browserVersion'){
			next();
		}else{
			next('/browserVersion');
		}

		return;
	} else {
		if(to.fullPath === '/browserVersion'){
			next({name: (rd == 'browserVersion'?'index':rd)});
			return;
		}
	}

	if(un) {
		// /* 已登录 */
		if(tAuth == 0) {
			/* 不需要认证页面，不能到达 */
			if(to.fullPath === '/'){
				next();
			}else{
				next('/');
			}
			return;
		}
		// 记录登陆之前访问的模块
		local(tAuth, tn);
		/* 需要认证页面，可以到达 */
		next();
	} else {
		/* 未登录 */
		if(tAuth == 0 || tAuth == 1) {
			// 记录登陆之前访问的模块
			if(flag) {
				if(fAuth){
					local(fAuth, fn);
				}else{
					local(tAuth, tn);
				}
			}

			flag = true;

			/* 不需要认证页面，可以到达 */
			next();

			return;
		}
		/* 需要认证页面，不能到达 */
		if(to.fullPath == '/login'){
			next();
		}else{
			// 记录登陆之前访问的模块
			local(tAuth, tn);
			flag = false;

			next('/login');
		}
	}
}

router.beforeEach((to, from, next) => {
	if(from.name == null || to.name == 'login'){
		document.title = '新华乐育管理系统 物联网平台';
	}else if(to.name == 'register'){
		document.title = '新华乐育管理系统 物联网平台';
	}else{
		document.title = '新华乐育管理系统 物联网平台';
	}
	if(from.name == null || to.params.isLogin || to.name == 'login'){
		global_.loginInfo((f, data) => {
			isLogin(to, from, next);
		}, true);
	} else {
		isLogin(to, from, next);
	}
})

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js